import CustomForm from "../../CustomForm";
import m, {Vnode, VnodeDOM} from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";
import AudioPlayer from "../../shared/components/MediaPlayer/AudioPlayer";
import {TextboxItem} from "../../../model/items/textbox";
import {CheckboxItem} from "../../../model/items/checkbox";

export default class PlayerTest extends CustomForm  {

    private static readonly SOUNDS = ['cock', 'horse', 'saxophone', 'tram'];
    private static readonly ICONS = ['cock', 'horse', 'saxophone', 'tram-side'];
    private static readonly SOUND_PATH = "//se2-dev.nms.cz/resources/sounds/";

    private drawnSound: number;
    private selectedSound: number|null = null;
    private attempts = 0;
    private showOptions: boolean;
    private showHelp = false;
    private finished: boolean;
    
    private player: AudioPlayer;
    private validateItem: TextboxItem;
    private screenoutItem: CheckboxItem;

    public readonly self: PlayerTest;

    constructor(settings: ICustomFormSettings) {
        super(settings);
        this.self = this;

        const layout = settings.form.grid.layout;
        this.validateItem = <TextboxItem>layout[0][0].cellItems[0];
        this.screenoutItem = <CheckboxItem>layout[1][0].cellItems[0];

        const validation = Number(this.validateItem.getVariable());
        this.finished = validation >= 10;
        this.drawnSound = this.finished ? validation-10 : Math.floor(Math.random()*PlayerTest.SOUNDS.length);
        this.showOptions = this.finished;
        this.selectedSound = this.finished ? this.drawnSound : null;

        this.player = new AudioPlayer(
           PlayerTest.SOUND_PATH+PlayerTest.SOUNDS[this.drawnSound]+'.mp3',
            {
                autoplay: false,
                enableSeek: true,
                minElapsedTime: 0.1,
                type: "audio/mpeg",
                skin: "simple",
            },
            () => this.showOptions = true,
        );

        this.controls.onNext = this.onNext.bind(this);
    }

    checkRequirements(): boolean {
        if (!this.validateItem) {
            console.log(`customForm-Player-test: Textbox to check fulfilled on position 0,0 missing.`);
            return false;
        }
        if (!this.screenoutItem) {
            console.log(`customForm-Player-test: Checkbox to screenout respondent on position 0,1 missing.`);
            return false;
        }
        return true;
    }

    private onNext(): void {
        if (this.finished) {
            this.settings.nextForm();
            return;
        }

        this.attempts++;
        if (this.selectedSound === this.drawnSound) {
            this.validateItem.setVariable(10+this.drawnSound);
            this.settings.nextForm();
            return;
        }

        if (this.attempts === 1) {
            this.validateItem.reset();
        } else if (this.attempts > 1) {
            this.screenoutItem.setVariable(this.drawnSound !== this.selectedSound);
            this.settings.nextForm();
        }
    }

    public view(): Vnode {
        return this.viewLayout([
            m('.test' + (this.showOptions?'.active':''), {}, [
                m(this.player),
                this.viewOptions(),
            ]),
            this.viewWarning(),
            this.viewHint(),
        ]);
    }

    private viewOptions(): Vnode {
        return m('.options', {}, [
            ...PlayerTest.ICONS.map( (icon, i) => {
                const selected = this.selectedSound===i;
                return m('.option' + (selected?'.selected':''), {
                    onclick: () => {
                        this.self.selectedSound = i;
                        if (!this.finished) {
                            this.self.validateItem.setVariable(this.attempts+1);
                        }
                    },
                }, [
                    m('i.icon.icon-' + icon+(selected?'.text-light':''))
                ]);
            })
        ]);
    }

    private viewWarning(): Vnode|null {
        const q = this.settings.form.questionary;
        return this.attempts ? m('.warning', {}, m.trust(q.renderText(q.messages.get('playerTestWarning')))) : null;
    }

    private viewHint(): Vnode|null {
        const q = this.settings.form.questionary;
        const message = this.finished ? 'playerFinished' : (this.showOptions ? 'playerChooseImageBySound' : 'playerClickToPlay');

        return m('.hint', {}, [
            m('.text-center', {}, q.renderText(q.messages.get(message))),
            m('.help'+(this.showHelp?'':'.clickable'),
                {
                    onclick: () => this.showHelp = !this.showHelp,
                },
                m.trust(q.renderText(q.messages.get(this.showHelp ? 'playerTroubleshooting' : 'playerHelp')))
            ),
        ]);
    }

    oncreate(vnode: VnodeDOM) {
        super.oncreate(vnode);
        this.player.volume(1);
    }

}
